module.exports = __webpack_public_path__ + "static/media/serviceBg01.72fef84a.jpg";